export default __webpack_public_path__ + "static/media/modalClose.db9c5c22.svg";